export const SET_ORDER_GUEST_CONFIGURATION = 'SET_ORDER_GUEST_CONFIGURATION';
export const SET_ORDER_RESPONSE = 'SET_ORDER_RESPONSE';
export const ADD_STAFF_CALL = 'ADD_STAFF_CALL';
export const CANCEL_STAFF_CALL = 'CANCEL_STAFF_CALL';
export const PAY_THE_ORDER_PAYMENT = 'PAY_THE_ORDER_PAYMENT';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const ADD_MENU_ID_TO_PROPS = 'ADD_MENU_ID_TO_PROPS';
export const ADD_INVOICE = 'ADD_INVOICE';
export const RESET_PAYMENTS = 'RESET_PAYMENTS';
export const SET_TIP_CONFIG = 'SET_TIP_CONFIG';
